import type { FaireProductEntity } from "../../entity_types/product";

export const p_65ksccycyt: FaireProductEntity = {
  token: "p_65ksccycyt",
  type: "product",
  name: "You Are Amazing: Quotes and Statements",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/7b60d29b2cd8f4738d70acee0e3f3ed3b08876173a9a6069c793a06f8402c451.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/57911cd0c4eec09be9a898a6d42c91947b286a04b238569bcfecbdbd881bc732.jpeg",
    "https://cdn.faire.com/fastly/f1a87a1f88cc3914bf4215594dfa399f9dd530936a4333aa645ebcd5f490a468.jpeg",
    "https://cdn.faire.com/fastly/7b9e6124b0da3316fc09f47e2d0db7bc043d5ea0f51db14ffb37e2422a2bfd69.jpeg",
    "https://cdn.faire.com/fastly/21b23c229b84cf594e3a61b30c6eb7e7e5144ac6976764890337e85557e2ec75.jpeg"
  ],
  priceDollars: 6.5,
  description: "Celebrate everything that makes you wonderfully unique with the congratulatory quotes and triumphant affirmations in this pocket-sized dose of positivity\n\nThere's so much that's great about you - so much that's worth honoring and cherishing - and there's no time like the present to acknowledge this! This little book of quotes is full of words of gratitude and appreciation that will make you recognize and remember that you are special and you are loved.\n\nFrom the timeless ideas of ancient sages to brilliant insights from modern superstars, these are words to encourage, congratulate and inspire.\n\nAs well as the heartfelt wisdom of successful writers, artists and thinkers, this book includes a host of encouraging affirmations and daily reminders such as:\n\n- The universe has good things in store for you\n- Be proud of everything you've accomplished\n- You can achieve anything you put your mind to\n- You are worthy of love and kindness\n- You are so much stronger than you think\n- The best version of you is just the way you are",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:07:10.320Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
